import React from 'react';

const OutreachPage: React.FC = () => (
  <div>
    <h1 className="text-3xl font-bold mb-4">Outreach Page</h1>
    <p className="text-gray-700">Work in progress...</p>
  </div>
);

export default OutreachPage;
